/**
 * 所有模块接口列表
 */
import {
  BASE_URL
} from '../../config/env'
import axios from '../request/http' // 导入http中创建的axios实例
import qs from 'qs' // 根据需求是否导入qs模块

//设置代理跨域通道
/*if (process.env.NODE_ENV === "development") {
  //开发环境下的代理地址，解决本地跨域跨域
  //项目域名地址
  axios.defaults.baseURL = "/invoker/"
} else {
  axios.defaults.baseURL = BASE_URL
}*/

//网关通道
axios.defaults.baseURL = BASE_URL
// 本地对接接口
// let url = "http://192.168.100.36:21002/invoker/"
let url = ""


//系统模块
const systemModule = {
  //登陆
  login (params) {
    return axios.post(`login`, params)
  },
  //身份校验 accessToken为登录token
  userValidator (params) {
    return axios.post(`queryUserInfo`, params)
  },
  //修改、忘记密码
  changePassword (params) {
    return axios.post(`changePwd`, params)
  },
  //忘记密码
  forgetPassword (params) {
    return axios.post(`accesstoken`, params)
  },
  //发送验证码 use 1注册2找回密码3登录
  sendCode (mobile, use) {
    return axios.get(`smsCode/${mobile}/${use}`)
  },
  //退出登录
  logout (params) {
    return axios.post(`logout`, params)
  },
  //上传图片
  uploadFile (params, config) {
    return axios.post(`file/uploadFile`, params, config)
  },
  //获取用户认证信息
  queryUserFullInfo (params) {
    return axios.post(`authorize/admin/queryUserFullInfo`, params)
  },
  //查询完整用户信息接口
  queryUserAllInfo (params) {
    return axios.post(`queryUserAllInfo`, params)
  },
  //获取用户岗位及权限信息
  queryUserPermit (userId, type) {
    return axios.get(`queryUserPermit/${userId}/${type}`)
  },
  //消息管理
  messageManage: {
    //获取列表、查询
    getList (params) {
      return axios.post(`email/searchEmailList`, params)
    },
    //发布/撤回/删除
    operateHandle (params) {
      return axios.post(`email/operate`, params)
    },
    //发送通知
    sendCircular (params) {
      return axios.post(`email/sendCircular`, params)
    },
    //发送公告
    sendNotice (params) {
      return axios.post(`email/sendNotice`, params)
    },
    //查看消息详情
    viewInfo (id) {
      return axios.get(`email/viewInfo/${id}`)
    }
  },
  //下载委托合同、成交合同
  downloadContractInfoByContractNo (params) {
    return axios.post(`cargo/downloadContractInfoByContractNo`, params)
  }

}
//会员管理
const memberManage = {
  //获取列表、查询
  getList (params) {
    return axios.post(`authorize/applyAuditList`, params)
  },
  //查看详情
  auditApplyInfo (id) {
    return axios.get(`authorize/auditApplyInfo/${id}`)
  },
  //审核
  audit (params) {
    return axios.post(`authorize/ac/audit`, params)
  }
}

//质检管理
const qualityControl = {
  //商品管理（标的）
  goodsManage: {
    //获取列表、查询
    getList (params) {
      return axios.post(`productInfo/queryPageByVo`, params)
    },
    //新增
    add (params) {
      return axios.post(`productInfo/saveProductInfo`, params)
    },
    //通过id查询
    getDataById (productId) {
      return axios.get(`productInfo/queryOne/${productId}`)
    },
    //弹窗修改
    edit (params) {
      return axios.post(`productInfo/saveProductInfo`, params)
    },
    //删除单个、批量删除
    batchEdit (params) {
      return axios.post(`productInfo/deleteProductInfo`, params)
    }
  },
  //检测项管理
  detectionItemManage: {
    //获取列表 商品id productId
    getList (productId) {
      return axios.get(`productInfo/queryChkQltyByProdId/${productId}`)
    },
    //查询
    search (params) {
      return axios.post(`productInfo/queryProductChkQlty`, params)
    },
    //新增、编辑 同一个接口， id是 检测项id   productId是商品id
    addEdit (params) {
      return axios.post(`productInfo/saveProdChkQlty`, params)
    },
    //删除单个、批量删除  检测项id
    batchEdit (prodChkQltyId) {
      return axios.get(`productInfo/deleteChkQlty/${prodChkQltyId}`)
    }
  },
  //瑕疵项管理
  flawManage: {
    //获取列表 商品id productId
    getList (productId) {
      return axios.get(`productInfo/queryFlawByProductId/${productId}`)
    },
    //查询
    search (params) {
      return axios.post(`productInfo/queryFlaw`, params)
    },
    //新增、编辑 同一个接口， id是瑕疵id   productId是商品id
    addEdit (params) {
      return axios.post(`productInfo/saveFlaw`, params)
    },
    //删除单个、批量删除  瑕疵项id
    batchEdit (prodFlawId) {
      return axios.get(`productInfo/deleteFlaw/${prodFlawId}`)
    }
  },
  //规格管理
  specsManage: {
    //获取列表 商品id productId
    getList (productId) {
      return axios.get(`productInfo/querySpecificationByProductId/${productId}`)
    },
    //查询
    search (params) {
      return axios.post(`productInfo/querySpecificationByProductRule`, params)
    },
    //新增、编辑 同一个接口， id是规格id   productId是商品id
    addEdit (params) {
      return axios.post(`productInfo/saveProductSpecification`, params)
    },
    //删除单个、批量删除  规格id ruleId
    batchEdit (ruleId) {
      return axios.get(`productInfo/deleteByProductRuleId/${ruleId}`)
    }
  },
  //分类管理
  classifyManage: {
    //获取列表 商品id productId
    getList (productId) {
      return axios.get(`productInfo/queryTypeByProductId/${productId}`)
    },
    //查询
    search (params) {
      return axios.post(`productInfo/queryProductType`, params)
    },
    //新增、编辑 同一个接口， id是规格id   productId是商品id
    addEdit (params) {
      return axios.post(`productInfo/saveType`, params)
    },
    //删除单个、批量删除  规格id ruleId
    batchEdit (prodTypeId) {
      return axios.get(`productInfo/deleteType/${prodTypeId}`)
    }
  },
  //质检套餐管理
  setMealManage: {
    //获取列表
    getList (params) {
      return axios.post(`chkQltyMeal/queryPageByVo`, params)
    },
    //查询
    /* search (params) {
        return axios.post(`productInfo/queryPageByVo`, params)
    }, */
    //新增、编辑 同一个接口
    addEdit (params) {
      return axios.post(`chkQltyMeal/saveChkQltyMeal`, params)
    },
    //通过id查询
    getDataById (chkQltyMealId) {
      return axios.get(`chkQltyMeal/queryDetailByMealId/${chkQltyMealId}`)
    },
    //审核提交
    verify (params) {
      return axios.post(`chkQltyMeal/verify`, params)
    }
  },
  //质检管理-质检管理
  qualityControlManage: {
    //获取列表
    getList (params) {
      return axios.post(`chkQltyReport/qualityControlList`, params)
    },
    //受理
    acceptance (params) {
      return axios.post(`chkQltyReport/acceptance`, params)
    },
    //根据批次查询委托信息
    queryEntrustInfo (batchId, batchNo) {
      return axios.get(`chkQltyReport/queryEntrustInfo/${batchId}/${batchNo}`)
    },
    //查看商品默认套餐
    queryQCCombo (productId) {
      return axios.get(`chkQltyReport/queryQCCombo/${productId}`)
    },
    //上传质检
    saveChkQltyReport (params) {
      return axios.post(`chkQltyReport/saveChkQltyReport`, params)
    },
    //可拍审核
    reportAudit (params) {
      return axios.post(`chkQltyReport/reportAudit`, params)
    },
    //根据质检单号查看质检单基本信息
    getReportByReportId (reportId) {
      return axios.get(`chkQltyReport/getReportByReportId/${reportId}`)
    },
    //根据批次号查询质检报告pdf文件
    getQCInfoPDFByBatchNo (batchId, batchNo) {
      return axios.get(`chkQltyReport/getQCInfoPDFByBatchNo/${batchId}/${batchNo}`)
    },
    //根据质检单号查询质检报告瑕疵
    getFlawByReportId (reportId) {
      return axios.get(`chkQltyReport/getFlawByReportId/${reportId}`)
    },
    //根据质检单号查询质检报告质检项
    getItemByReportId (reportId) {
      return axios.get(`chkQltyReport/getItemByReportId/${reportId}`)
    }
  }
}

//仓储物流管理
const warehouseLogistics = {
  baseData: {
    //仓库管理
    storehouse: {
      //列表、查询
      getList (params) {
        // return axios.post(`storehouse/searchStorehouseList`, params)
        return axios.post(`storehouse/queryStoreHousePage`, params)
      },
      //新增、编辑
      addEdit (params) {
        return axios.post(`storehouse/addOrEditStorehouse`, params)
      },
      //通过id查询
      getDataById (id) {
        return axios.get(`storehouse/searchStorehouse/${id}`)
      },
      //删除仓库-验证是否有正在使用的筐
      verificationStorehouse (storehouseCode) {
        return axios.get(`storehouse/verificationStorehouse/${storehouseCode}`)
      },
      //单个删除
      batchEdit (id) {
        return axios.get(`storehouse/deleteStorehouse/${id}`)
      }
    },
    //库区管理
    warehouse: {
      //列表、查询
      getList (params) {
        return axios.post(`warehouse/searchWarehouseList`, params)
      },
      //新增、编辑
      addEdit (params) {
        return axios.post(`warehouse/addOrEditWarehouse`, params)
      },
      //通过id查询
      getDataById (id) {
        return axios.get(`warehouse/selectWarehouse/${id}`)
      },
      //删除库区-验证是否有正在使用的筐
      verificationWarehouse (warehouseCode) {
        var params ={'warehouseCode':warehouseCode}
        return axios.post(`warehouse/verificationWarehouse`,params)
      },
      //单个删除
      batchEdit (id) {
        return axios.get(`warehouse/deleteWarehouse/${id}`)
      },
      //获取所有仓库
      getStorehouseName () {
        // return axios.post(`warehouseSeat/getStorehouseName`)
        return axios.post(`storehouse/queryStoreHouseList`)
      }
    },
    //包材资料管理
    material: {
      //列表、查询
      getList (params) {
        return axios.post(`material/queryPageByMaterial`, params)
      },
      //新增、编辑
      addEdit (params) {
        return axios.post(`material/saveMaterial`, params)
      },
      //通过id查询
      getDataById (id) {
        return axios.get(`material/queryMaterialDtl/${id}`)
      },
      //单个删除
      batchEdit (id) {
        return axios.get(`material/deleteMaterial/${id}`)
      }
    },
    //库位管理
    warehouseSeat: {
      //获取仓库名称
      getStorehouseName () {
        // return axios.post(`warehouseSeat/getStorehouseName`)
        return axios.post(`storehouse/queryStoreHouseList`)
      },
      //根据仓库获取库区
      getWarehouseName (params) {
        return axios.post(`warehouseSeat/queryWarehouseList`, params)
      },
      //列表
      getList (params) {
        return axios.post(`warehouseSeat/searchWarehouseSeatList`, params)
      },
      //新增、编辑
      addEdit (params) {
        return axios.post(`warehouseSeat/addOrEditWarehouseSeat`, params)
      },
      //通过id查询
      getDataById (id) {
        return axios.get(`material/queryMaterialDtl/${id}`)
      },
      //批量添加库位
      batchAddStorehouse (params) {
        return axios.post(`warehouseSeat/batchAddStorehouse`, params)
      },
      //单个删除
      batchEdit (id, seatCode) {
        return axios.get(`warehouseSeat/deleteWarehouseSate/${id}/${seatCode}`)
      }
    },
    //包材管理
    packingManagement: {
      //列表、查询
      getList (params) {
        return axios.post(`material/materialInfoList`, params)
      },
      //新增
      add (params) {
        return axios.post(`material/addMaterialInfo`, params)
      },
      //启用、报废
      enableOrWaste (params) {
        return axios.post(`material/enableOrWaste`, params)
      },
      //获取所有包材类型
      getBasketType () {
        return axios.post(`material/getBasketType`)
      }
    }
  },
  //收货管理
  receivingManage: {
    //预约管理
    appointmentManage: {
      //初检预约受理
      //列表、查询
      getList (params) {
        return axios.post(`appointment/appointmentList`, params)
      },
      //预约确认
      appointmentConfirm (id) {
        return axios.get(`appointment/appointmentConfirm/${id}`)
      },
      //确认到货
      confirmArrival (id) {
        return axios.get(`appointment/confirmArrival/${id}`)
      },
      //初检审核
      firstExamination (params) {
        return axios.post(`appointment/firstExamination`, params)
      },
      //委托录单
      recordSheet (params) {
        return axios.post(`cargo/recordSheet`, params)
      },
      //获取规格和分类
      selectRuleOrType (params) {
        return axios.post(`cargo/selectRuleOrType`, params)
      },
      //模糊查询商品
      selectProductName (params) {
        return axios.post(`cargo/selectProductName`, params)
      }
    },
    //委托管理
    entrustManage: {
      //列表、查询
      getList (params) {
        return axios.post(`cargo/searchList`, params)
      },
      //合同补充说明
      addEntrustPact (params) {
        return axios.post(`cargo/addEntrustPact`, params)
      },
      //审核委托信息查询
      queryEntrustDetails (id) {
        return axios.get(`cargo/queryEntrustDetails/${id}`)
      },
      //租赁委托信息详情查询
      queryCargoById (params) {
        return axios.post(`cargo/queryCargoById`, params)
      },
      //审核委托信息提交
      auditEntrustment (params) {
        return axios.post(`cargo/auditEntrustment`, params)
      },
      //查看委托单-委托合同
      getContractInfoByContractNo (params) {
        return axios.post(`cargo/getContractInfoByContractNo`, params)
      },
      //打印收货单-直接下载
      printSHInfo (cargoId, params = {}) {
        return axios.get(`cargo/printSHInfo/${cargoId}`, params)
      },
      //打印收货单-直接调用window打印
      printSHInfoWindow (cargoId) {
        return axios.get(`cargo/shInfo/${cargoId}`)
      },
      //线下合同签订
      signUnderEntrustPact (params) {
        return axios.post(`cargo/signUnderEntrustPact`, params)
      },
      //修改保留价
      updateReservePrice (params) {
        return axios.post(`cargo/updateReservePrice`, params)
      },
      //委托录单
      insertCargo (params) {
        return axios.post(`cargo/insertCargo`, params)
      },
      //通过品种获取规格数据
      queryProductByName (params) {
        return axios.post(`productInfo/queryProductByName`, params)
      },
      //仓储订单支付
      paymentByStorageFee (params) {
        return axios.post(`storageFee/paymentByStorageFee`, params)
      },
      //仓储订单免单
      setFreeCharge (params) {
        return axios.post(`storageFee/setFreeCharge`, params)
      },
      //仓储订单轮询
      findById (id) {
        return axios.get(`storageFee/findById/${id}`)
      },
    }
  },
  //移库管理
  moveLibraryManage: {
    moveLibraryTask: {
      //列表、查询
      getList (params) {
        return axios.post(`cargoWarehouseRecord/queryPageByCargoWarehouseRecord`, params)
      },
      //驳回/接收 接收：RECEIVE；驳回：REJECT
      updateManipulate (params) {
        return axios.post(`cargoWarehouseRecord/updateManipulate`, params)
      },
      //查看（确认审核详情）
      show (params) {
        return axios.post(`cargoWarehouseRecord/selectDtl`, params)
      },
      //手动移库
      manualMovingLibrary (params) {
        return axios.post(`cargoWarehouseRecord/manualMovingLibrary`, params)
      },
      //确认审核
      exminedConfirm (params) {
        return axios.post(`cargoWarehouseRecord/exminedConfirm`, params)
      }
    }
  },
  //库存管理
  inventoryManage: {
    //库存查询
    inventoryQuery: {
      //列表、查询
      getList (params) {
        return axios.post(`cargo/stockQueryList`, params)
      },
      //库存冻结
      stockFrozen (cargoId, status) {
        return axios.get(`cargo/stockFrozen/${cargoId}/${status}`)
      },
      //查看库存详情
      show (params) {
        return axios.post(`cargo/stockDetails`, params)
      },
      //查看库存详情-冻结、解冻  N：冻结，Y：解冻
      basketFrozen (id, status) {
        return axios.get(`cargo/basketFrozen/${id}/${status}`)
      },
      //移库
      confirmShiftIn (params) {
        return axios.post(`cargoWarehouseRecord/confirmShiftIn`, params)
      },
      //出库申请
      createPickRecord (params) {
        return axios.post(`picking/createPickRecord`, params)
      }
    },
    //库存盘点
    inventoryCheck: {
      //列表、查询
      getList (params) {
        return axios.post(`takeStockInfo/inventoryList`, params)
      },
      //盘点
      checkStock (params) {
        return axios.post(`takeStockInfo/checkStock`, params)
      }
    },
    //盘盈亏审核
    earningsLosses: {
      //列表、查询
      getList (params) {
        return axios.post(`takeStockInfo/inventoryExamineList`, params)
      },
      //审核信息查询
      show (id) {
        return axios.get(`takeStockInfo/examineQuery/${id}`)
      },
      //审核
      examineAndVerify (params) {
        return axios.post(`takeStockInfo/examineAndVerify`, params)
      }
    }
  },
  //出库管理
  outOfStockManage: {
    //列表、查询
    getList (params) {
      return axios.post(`shipment/queryPageByShipment`, params)
    },
    //列表批准
    depotApproval (params) {
      return axios.post(`shipment/depotApproval`, params)
    },
    //列表出库
    detailsCK (params) {
      return axios.post(`shipment/detailsCK`, params)
    },
    //出货单详情
    shipmentDetails (params) {
      return axios.post(`shipment/shipmentDetails`, params)
    },
    //手动出库
    manualDepot: {
      //手动出库列表
      getList (params) {
        return axios.post(`shipment/manualDepot`, params)
      },
      //手动出库-手动出库验证退货区是否已完成移库
      moveLibraryYesOrNo (params) {
        return axios.post(`shipment/moveLibraryYesOrNo`, params)
      },
      // //手动出库-出库
      // outOfStock (params) {
      //   return axios.post(`shipment/outOfStock`, params)
      // }
      //手动出库-出库-新
      outOfStock (id, params) {
        return axios.post(`shipment/outOfStock/${id}`, params)
      }
    },
    //打印出库单-直接下载
    printShipment (id, params = {}) {
      return axios.get(`shipment/printShipment/${id}`, params)
    },
    //打印出库单-直接调用window打印
    printShipmentWindow (id) {
      return axios.get(`shipment/fhInfo/${id}`)
    },
    //移库到成交/提货验证接口
    moveLibraryByCJQ (params) {
      return axios.post(`cargoWarehouseRecord/moveLibraryByCJQ`, params)
    },
  }
}

// 拍卖
const auctionModule = {
  auctionIndex: {
    // 拍卖首页查询列表
    queryPageList (params) {
      return axios.post(`${url}auction/management/queryPageByAuctionMeetingInfo`, params)
    },
    // 删除拍卖场次
    deleteAuction (id) {
      return axios.post(`${url}auction/management/deleteAuctionMeetingInfo/${id}`);
    },
    //  启动拍卖场次
    startAuction (meetingId) {
      return axios.get(`${url}auction/management/startAuction/${meetingId}`);
    }
  },
  //发布拍卖
  pushAuction: {
    // 上传发布信息
    saveAuction (params) {
      return axios.post(`${url}auction/management/saveAuctionMeetingInfo`, params)
    },
    // 上传附件
    uploadFiles (id, params) {
      return axios.post(`${url}auction/management/uploadFile/${id}`, params)
    },
    // 删除附件
    delUploadFile (params) {
      return axios.post(`${url}auction/management/delUploadFile`, params)
    },
    // 查看附件
    queryUpFiles (id) {
      return axios.post(`${url}auction/management/queryUploadFile/${id}`)
    },
    // 查询拍卖场次
    queryAuction (id) {
      return axios.get(`${url}auction/management/queryAuctionMeetingInfo/${id}`)
    },
    // 新增或者更新屏幕信息
    saveScreenConfig (params) {
      return axios.post(`${url}auction/management/saveScreenConfig`, params)
    },
    // 提交场次审核申请
    pendingMeeting (meetingId) {
      return axios.post(`${url}auction/management/pendingMeeting/${meetingId}`)
    },
    // 获取标的列表
    getTargetList (params) {
      return axios.post(`cargo/targetList`, params)
    },
    // 获取规格和分类
    getRuleOrType (params) {
      return axios.post(`${url}cargo/selectRuleOrType`, params)
    },
    // 添加标的
    addMeetingLotInfo (id, params) {
      return axios.post(`${url}auction/management/addMeetingLotInfo/${id}`, params)
    },
    // 删除标的
    deleteMeetingLotInfo (params) {
      return axios.post(`${url}auction/management/deleteMeetingLotInfo`, params)
    },
    // 更新标的的信息
    updateMeetingLotInfo (params) {
      return axios.post(`${url}auction/management/updateMeetingLotInfo`, params)
    },
    // 查询批次列表
    queryLotInfoList (params) {
      return axios.post(`${url}auction/management/queryLotInfoList`, params)
    },
    // 移除屏幕标的（批次）信息
    deleteScreenLot (id, batchId) {
      return axios.post(`${url}auction/management/deleteScreenLot/${id}/${batchId}`)
    },
    //添加标的 - 查看批次是否已完成移库
    moveLibraryByDPQ (params) {
      return axios.post(`/cargoWarehouseRecord/moveLibraryByDPQ`, params)
    },
    // 根据角色 id 查询管理员信息
    findSysUserByRID (roleId) {
      return axios.get(`/findSysUserByRID/${roleId}`)
    }
  },
  // 上传保证金保证金 与 采购货物总价比例
  addAuctionDepositConfig (params) {
    return axios.post(`${url}auction/management/addAuctionDepositConfig`, params)
  },
  // 删除保证金
  deleteAuctionDepositConfig (id) {
    return axios.post(`${url}auction/management/deleteAuctionDepositConfig/${id}`)
  },
  // 排序互换
  swopLotSort (id1, id2) {
    return axios.post(`${url}auction/management/swapLotSort/${id1}/${id2}`)
  },
  // 撤标管理
  ReviewMark: {
    // 拍卖标的 - 查看委托人批次撤销申请列表
    queryPageByLotRevocationInfo (params) {
      return axios.post(`${url}/auction/management/queryPageByLotRevocationInfo`, params)
    },
    // 拍卖标的 - 审核委托人批次撤销的申请（触发下单）
    auditLotRevocation (params) {
      return axios.post(`${url}/auction/management/auditLotRevocation`, params)
    },
    // 拍卖场次 - 场次结束后导出竞价记录（拍卖场记）
    downBidInfoList (bidId, params = {}) {
      return axios.get(`${url}/auction/management/downBidInfoList/${bidId}`, params)
    }
  },

  // 审核拍卖
  auditAuction: {
    // 审核拍卖
    auditAuctionMeeting (params) {
      return axios.post(`${url}auction/management/auditAuctionMeeting`, params)
    },
    // 发布 审核通过的
    publicityMeeting (id) {
      return axios.post(`${url}auction/management/publicityMeeting/${id}`)
    }
  },
  // 查看预约
  queryDepositInfo (params) {
    return axios.post(`${url}auction/management/queryDepositInfoByMeeting`, params)
  },
  // 控制场次的拍卖状态
  meetingState (params) {
    return axios.post(`${url}auction/meetingState`, params)
  },
  // 控制拍卖时 的拍卖状态
  controlScreenState (params) {
    return axios.post(`${url}auction/controlScreenState`, params)
  },
  // 查询场次的所有批次拍卖结束后的成交情况
  queryMeetingSoldList (meetingId) {
    return axios.post(`${url}auction/management/queryMeetingSoldList/${meetingId}`)
  },
  //场次结束后查询批次中标列表
  queryLotSoldList (batchId) {
    return axios.post(`${url}auction/management/queryLotSoldList/${batchId}`)
  },
  // 批次审核结束后进行确认接口 （触发下单）
  submitLotSoldInfo (batchId) {
    return axios.post(`${url}auction/management/submitLotSoldInfo/${batchId}`)
  },
  // 审核竞拍结果移除竞价记录
  delLotSoldInfo (soldId) {
    return axios.post(`${url}auction/management/delLotSoldInfo/${soldId}`)
  },
  // 场次结束后审核批次中标
  auditLotSoldInfo (params) {
    return axios.post(`${url}auction/management/auditLotSoldInfo`, params)
  },
  // 导出可拍的标的列表
  downCargoList (params = {}) {
    return axios.get(`${url}/auction/management/downCargoList`, params)
  }
}

//订单管理
const orderManage = {
  transactionOrderManage: {
    //列表、查询
    getList (params) {
      return axios.post(`auction/management/selectSoldCollection`, params)
    }
  }
}
export default {
  memberManage,
  systemModule,
  qualityControl,
  warehouseLogistics,
  auctionModule,
  orderManage
}



// WEBPACK FOOTER //
// ./src/api/api.js